import Fade from "@material-ui/core/Fade";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import * as Sentry from "@sentry/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContactUsMessage } from "../../store/actions/ContactActions";

// import { GoogleLogin, GoogleLogout } from "react-google-login";
// import FacebookLogin from "react-facebook-login";
// import AppleLogin from "react-apple-login";

function WemoovezLogin() {
  const { loginInfo } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    try {
      if (loginInfo?.id) {
        setEmail(loginInfo.email);
        setName(loginInfo.firstName + " " + loginInfo.lastName);
        setcontactObj({
          ...contactObj,
          UserId: loginInfo?.id,
        });
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [loginInfo]);
  //contact object
  const [contactObj, setcontactObj] = useState({
    id: 0,
    Name: "",
    Email: "",
    Message: "",
    UserId: "",
  });

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  // dispatch actions
  const dispatch = useDispatch();
  // email
  const [email, setEmail] = useState("");
  // name
  const [name, setName] = useState("");
  // complain
  const [message, setMessage] = useState("");

  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  // Sign In
  const handleSubmitComplain = () => {
    try {
      if (contactObj) {
        if (name) {
          if (email) {
            if (message) {
              dispatch(
                ContactUsMessage(
                  { ...contactObj, Email: email, Name: name, Message: message },
                  setStatus,
                  setError
                )
              ).then((data) => {
                console.log("response from contact us", data);
                if (data.statusCode === 200) {
                  setOpen(true);
                  setMessage("");
                  // set timeout then refresh screen
                }
              });
            } else {
              alert("please enter messsage");
            }
          } else {
            alert("please enter email");
          }
        } else {
          alert("please enter name");
        }
      } else {
        alert("Please fill all the fields");
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  //Modal styles
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <div className="flex items-start justify-center px-4 w-full pt-6 pb-4" style={{ minHeight: 'calc(100vh - 60px)' }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="max-w-md">
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Thanks for reaching out! We will review your message and get back to you within 24 hours.
          </Typography>

          <div className="mt-6 flex justify-end">
            <button
              onClick={() => {
                setOpen(false);
                if (!loginInfo?.email) {
                  setEmail("");
                  setName("");
                  setMessage("");
                }
              }}
              className="bg-[#34318C] text-white px-6 py-2 rounded-lg hover:opacity-95"
            >
              Ok
            </button>
          </div>
        </Box>
      </Modal>

      <div className="w-full max-w-container mx-auto">
        <div className="flex flex-col items-start gap-1 mb-6">
          <h1 className="text-[#211F59] text-2xl font-semibold">Contact Us</h1>
          <p className="text-[#211F59] text-sm font-semibold">Please share your message and we'll get back within 24 hours.</p>
        </div>

        <div className="space-y-4">
          {!loginInfo?.email && (
            <input
              value={name}
              placeholder="Name"
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] px-3 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
            />
          )}

          {!loginInfo?.email && (
            <input
              value={email}
              placeholder="Email address"
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] px-3 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
            />
          )}

          <textarea
            value={message}
            placeholder="Message"
            onChange={(e) => setMessage(e.target.value)}
            className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] px-3 py-3 rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1] h-36 resize-none"
          />

          {error ? (
            <div>
              <Fade in={error === true} timeout={1000}>
                <p className="text-sm text-red-500">{String(error)}</p>
              </Fade>
            </div>
          ) : null}

          <div className="flex flex-col gap-3">
            <button
              className="w-full mt-[8px] bg-[#34318C] text-white rounded-[12px] px-6 h-[48px] text-sm font-medium hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={handleSubmitComplain}
            >
              Submit
            </button>

            <div className="text-center mx-auto text-[13px] text-[#211F59] mt-[3px]">
              Please feel free to submit a message here or call us at <br /><a href="tel:+18253055300" className="font-bold underline">+1 (825) 305-5300</a> with any questions or concerns. Our team is always here to help!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WemoovezLogin;
